import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../hooks/use-stores';
import { useTranslation } from 'react-i18next';
import { VideoPlayer } from '@awarego/awarego-components';
import keyBy from 'lodash/keyBy';
import ThemedSpinner from '../components/themed/ThemedSpinner';

export default observer(
    ({
        subject,
        logEvent,
        onChange,
        enableAssessmentFinish,
        onLastDecision,
        resetDecisions,
        videoTokenStore,
    }) => {
        const { store } = useStores();
        const { t } = useTranslation();
        const [token, setToken] = useState(null);

        const { videoPlayerUrl } = store;
        const { tokens, tokenIndex } = videoTokenStore;

        const videoTokenRequested = async (predefinedSubjectId) => {
            const subjectId =
                predefinedSubjectId || subject.id || subject.subject_id;
            await videoTokenStore.videoToken(subjectId);
            let tokenArray = keyBy(tokens, 'id');
            setToken(tokenArray[subjectId]);
        };

        useEffect(() => {
            const loadVideoData = async () => {
                const subjectId = subject.id || subject.subject_id;
                if (!store.videoPlayerUrl)
                    await store.loadVideoPlayerUrl(subjectId);
                if (subject && subjectId && !tokenIndex[subjectId]) {
                    await videoTokenStore.videoToken(subjectId);
                }
                let tokenArray = keyBy(tokens, 'id');
                setToken(tokenArray[subjectId]);
            };

            loadVideoData();
        }, [store, videoTokenStore, subject, tokens]);

        return store.loadingVideoUrl ? (
            <ThemedSpinner />
        ) : (
            token && (
                <VideoPlayer
                    videoTokenRequested={videoTokenRequested}
                    token={token && token.token}
                    videoPlayerUrl={videoPlayerUrl}
                    t={t}
                    subject={subject}
                    logEvent={logEvent}
                    onChange={onChange}
                    enableAssessmentFinish={enableAssessmentFinish}
                    presetCaptionsLanguage={store.playerPresetCaptionsLanguage}
                    captionsSettings={store.playerCaptionsSettings}
                    onLastDecision={onLastDecision}
                    resetDecisions={() => {
                        resetDecisions();
                        subject.resetDecisions();
                    }}
                    onFinishedWatchingAnswer={() => {
                        subject.hasSeenAnswer();
                    }}
                />
            )
        );
    }
);
